<div class="unassigned-invoice-imports p-3">
  <h2>{{ 'INVOICE_IMPORTS.UNASSIGNED.TITLE' | translate }}</h2>
  <p class="text-muted">{{ 'INVOICE_IMPORTS.UNASSIGNED.SUBTITLE' | translate }}</p>

  <div class="alert alert-danger" *ngIf="loadError">{{ loadError }}</div>

  <div class="table-responsive" *ngIf="items.length">
    <table class="table table-hover">
      <thead>
        <tr>
          <th>{{ 'INVOICE_IMPORTS.UNASSIGNED.COL_FROM' | translate }}</th>
          <th>{{ 'INVOICE_IMPORTS.UNASSIGNED.COL_SUBJECT' | translate }}</th>
          <th>{{ 'INVOICE_IMPORTS.UNASSIGNED.COL_IDS' | translate }}</th>
          <th>{{ 'INVOICE_IMPORTS.UNASSIGNED.COL_RESOLUTION' | translate }}</th>
          <th>{{ 'INVOICE_IMPORTS.UNASSIGNED.COL_NOTE' | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of items">
          <td>{{ row.email?.from }}</td>
          <td>{{ row.email?.subject }}</td>
          <td class="small">{{ identifiers(row) }}</td>
          <td class="small">{{ storeResolutionLabel(row) }}</td>
          <td class="small">{{ resolutionNoteLabel(row) }}</td>
          <td>
            <button type="button" class="btn btn-sm btn-primary" (click)="openAssign(row)">
              {{ 'INVOICE_IMPORTS.UNASSIGNED.ASSIGN' | translate }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <p class="text-muted" *ngIf="!loadError && !items.length">{{ 'INVOICE_IMPORTS.UNASSIGNED.EMPTY' | translate }}</p>

  <div class="d-flex justify-content-between mt-3" *ngIf="total > limit">
    <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="page <= 1" (click)="onPageChange(page - 1)">‹</button>
    <span>{{ page }} / {{ Math.ceil(total / limit) }}</span>
    <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="page * limit >= total" (click)="onPageChange(page + 1)">›</button>
  </div>

  <div class="assign-panel card mt-3" *ngIf="assignImportId">
    <div class="card-body">
      <label class="form-label">{{ 'INVOICE_IMPORTS.UNASSIGNED.PICK_STORE' | translate }}</label>
      <select class="form-select mb-2" [(ngModel)]="selectedStoreId">
        <option value="">{{ 'INVOICE_IMPORTS.UNASSIGNED.PICK_STORE_PLACEHOLDER' | translate }}</option>
        <option *ngFor="let s of stores" [value]="s._id">{{ s.storeName || s.name }}</option>
      </select>
      <div class="d-flex gap-2">
        <button type="button" class="btn btn-primary" [disabled]="!selectedStoreId" (click)="confirmAssign()">
          {{ 'INVOICE_IMPORTS.UNASSIGNED.CONFIRM' | translate }}
        </button>
        <button type="button" class="btn btn-outline-secondary" (click)="cancelAssign()">{{ 'INVOICE_IMPORTS.COMMON.CANCEL' | translate }}</button>
      </div>
    </div>
  </div>
</div>
